import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// ---------- 401 session-expiry interceptor ----------
// Any 401 returned by the API (except on /auth/me probes and /auth/login attempts)
// triggers the registered handler. The AuthProvider uses it to reset its in-memory
// admin/user state, which causes the protected layouts to redirect to login.
let onAuthExpired = null;
export function registerAuthExpiredHandler(fn) { onAuthExpired = fn; }

function isProbe(url) {
    return /\/(admin\/)?auth\/(me|login|register|logout)\b/.test(url || "");
}

api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err?.response?.status;
        const url = err?.config?.url || "";
        if (status === 401 && onAuthExpired && !isProbe(url)) {
            const scope = url.includes("/admin/") ? "admin" : "public";
            onAuthExpired(scope);
        }
        return Promise.reject(err);
    },
);

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Une erreur est survenue.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" • ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
